export const BngDomainSuggestionsDataHooks = {
  moreAvailableExtensionsCta: 'bng-more-available-extensions-cta',
  domainSuggestionsSection: 'bng-domain-suggestions-section',
  domainSuggestionsError: 'bng-domain-suggestions-error',
  domainSuggestionsTitle: 'bng-domain-suggestions-title',
  pageLoadError: 'bng-page-load-error'
};
//# sourceMappingURL=dataHooks.js.map